import React, {Component} from 'react';

export default class PhotoEditor extends Component {
    constructor(props) {
        super(props);

        this.state = {
        	showDoneLayer: true
		};

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    show() {
    	this.setState({
			showDoneLayer: true
		});
	}

	hide() {
		this.setState({
			showDoneLayer: false
		});
	}

    render() {
        return (
			<div className="photos_editor photos_hide" data-click="wrapper:click">
				<strong className="photos_screen_out">Photos Web Editor</strong>
				<div className="photos_container_main">
					<div className="photos_vertical_photo">
						<div className="photos_preview_wrapper" >
							<div className="photos_preview_scale_wrapper">
								<canvas className="photos_preview_canvas" width="0" height="0" ></canvas>
								<canvas className="photos_preview_canvas_origin photos_hide" width="0" height="0" ></canvas>
								<canvas className="photos_preview_canvas_fake photos_hide" width="0" height="0" ></canvas>
								<canvas className="photos_preview_focus_layer photos_hide" width="0" height="0" ></canvas>
							</div>
							<div className="photos_preview_noscale_wrapper">
								<div className="photos_controls_deco"><pre className="text_proxy"><span className="proxy_get_size photos_hide"></span></pre></div>
								<div className="photos_controls_size photos_hide">
									<div className="photos_size_outline"></div>
								</div>
							</div>
						</div>
						<div className="photos_tools_wrapper">
							<div className="photos_tools_crop photos_hide">
								<div className="photos_crop_dimmed" >
									<div className="photos_crop_dimmed_top" ></div>
									<div className="photos_crop_dimmed_bottom" ></div>
									<div className="photos_crop_dimmed_left" ></div>
									<div className="photos_crop_dimmed_right" ></div>
								</div>
								<div className="photos_box_area">
									<div className="photos_crop_draggable"></div>
									<span className="photos_corner_area photos_corner_t"  data-click="crop:circle:n"></span>
									<span className="photos_corner_area photos_corner_l"  data-click="crop:circle:w"></span>
									<span className="photos_corner_area photos_corner_b"  data-click="crop:circle:s"></span>
									<span className="photos_corner_area photos_corner_r"  data-click="crop:circle:e"></span>
									<span className="photos_corner_area photos_corner_tl" data-click="crop:circle:nw"><span className="photos_corner_mark" data-click="crop:circle:nw"></span></span>
									<span className="photos_corner_area photos_corner_tr" data-click="crop:circle:ne"><span className="photos_corner_mark" data-click="crop:circle:ne"></span></span>
									<span className="photos_corner_area photos_corner_bl" data-click="crop:circle:sw"><span className="photos_corner_mark" data-click="crop:circle:sw"></span></span>
									<span className="photos_corner_area photos_corner_br" data-click="crop:circle:se"><span className="photos_corner_mark" data-click="crop:circle:se"></span></span>
									<div className="photos_line_edit photos_line_v photos_line_angle" style={{left: "11%"}}></div>
									<div className="photos_line_edit photos_line_v photos_line_angle" style={{left: "22%"}}></div>
									<div className="photos_line_edit photos_line_v" style={{left: "33%"}}></div>
									<div className="photos_line_edit photos_line_v photos_line_angle" style={{left: "44%"}}></div>
									<div className="photos_line_edit photos_line_v photos_line_angle" style={{left: "55%"}}></div>
									<div className="photos_line_edit photos_line_v" style={{left: "66%"}}></div>
									<div className="photos_line_edit photos_line_v photos_line_angle" style={{left: "77%"}}></div>
									<div className="photos_line_edit photos_line_v photos_line_angle" style={{left: "88%"}}></div>
									<div className="photos_line_edit photos_line_h photos_line_angle" style={{left: "%11"}}></div>
									<div className="photos_line_edit photos_line_h photos_line_angle" style={{top: "22%"}}></div>
									<div className="photos_line_edit photos_line_h" style={{top: "33%"}}></div>
									<div className="photos_line_edit photos_line_h photos_line_angle" style={{top: "44%"}}></div>
									<div className="photos_line_edit photos_line_h photos_line_angle" style={{top: "55%"}}></div>
									<div className="photos_line_edit photos_line_h" style={{top: "66%"}}></div>
									<div className="photos_line_edit photos_line_h photos_line_angle" style={{top: "77%"}}></div>
									<div className="photos_line_edit photos_line_h photos_line_angle" style={{top: "88%"}}></div>
								</div>
								<div className="photos_detail_info">
									<div className="photos_info_btn photos_info_rotate" >
										<div className="photos_wrap_rotate">
											<div className="photos_bg_photos photos_degree_input">
												<label htmlFor="degree" className="photos_screen_out">회전 각도 입력</label>
												<input type="text" id="degree" className="photos_inp_photos" maxLength="3" />
											</div>
											<button type="button" className="photos_ico_photos photos_btn_rotate_r" data-click="orientation:type:right">90도 회전</button>
											<button type="button" className="photos_ico_photos photos_btn_flip_h" data-click="orientation:type:horizontal">좌우반전</button>
										</div>
										<div className="photos_wrap_protractor">
											<canvas className ="photos_protractor" width="512" height="512" ></canvas>
										</div>
									</div>
								</div>
							</div>
							<div className="photos_tools_filter photos_hide">
								<button type="button" className="photos_btn_detail photos_btn_prev" data-click="filter:prev"><span className="photos_ico_photos photos_ico_prev">이전</span></button>
								<button type="button" className="photos_btn_detail photos_btn_next" data-click="filter:next"><span className="photos_ico_photos photos_ico_next">다음</span></button>
								<button type="button" className="photos_filter_origin"><span>원본</span></button>
							</div>
							<div className="photos_tools_effect_all photos_hide"></div>
						</div>

					</div>
					<div className="photos_quicklist_photo photos_hide">
						<strong className="photos_screen_out">사진 목록</strong>
						<div className="photos_quicklist_area">
							<div className="photos_scroll_wrap">
								<ul className="photos_list_quick"></ul>
							</div>
							<div className="photos_popup photos_hide" >
								<span className="photos_txt"></span>
								<span className="photos_ico_arr"></span>
							</div>
						</div>
					</div>
					<div className="photos_magnifier_photo">
						<div className="photos_inner_slider">
							<div className="photos_slider_bar pp_slider photos_icon_magnifier">
								<input className="pp_slider_input photos_hide" type="range" min="1" max="1.5" step="0.0025" orientation="vertical" start="1" />
							</div>
						</div>
					</div>
					<div className="photos_light_editor">
						<button type="button" className="photos_btn_light" data-click="light:switch"><span className="photos_ico_photos photos_ico_light">화이트 버전</span></button>
					</div>
					<div className="photos_cancel_area" style={this.state.showDoneLayer?{display:"block"}:{display:"none"}} >
						<button type="button" className="photos_btn_sub photos_btn_cancel" data-click="shortcut:cancel"><span className="photos_ico_back">취소</span></button>
						<button type="button" className="photos_btn_save" data-click="menu:save"><span className="photos_ico_save">저장</span></button>
					</div>
				</div>
				<div className="photos_tool_main">
					<div className="photos_wrap_menu">
						<div className="photos_wrap_menu_sub">
							<div className="photos_menu_sub_bg"></div>
							<div className="photos_menu_sub photos_menu_sub_filter">
								<strong className="photos_screen_out">필터 메뉴</strong>
								<div className="photos_list_wrapper photos_align_center">
									<ul className="photos_list_item photos_align_center photos_list_filter"></ul>
								</div>
								<button type="button" className="photos_menu_filter_prev photos_btn_detail photos_btn_prev photos_hide" data-click="filterNav:prev"><span className="photos_ico_photos photos_ico_prev">이전</span></button>
								<button type="button" className="photos_menu_filter_next photos_btn_detail photos_btn_next photos_hide" data-click="filterNav:next"><span className="photos_ico_photos photos_ico_next">다음</span></button>
							</div>
							<div className="photos_menu_sub photos_menu_sub_edit">
								<strong className="photos_screen_out">편집 메뉴</strong>
								<ul className="photos_list_item photos_align_center photos_list_edit">
									<li>
										<button type="button" className="photos_btn_item photos_menu_btn_crop" data-click="submenu:crop">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_crop"></span>
										<span className="photos_txt_item">편집</span>
									</span>
										</button>
									</li>
									<li>
										<button type="button" className="photos_btn_item photos_menu_btn_size" data-click="submenu:size">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_size"></span>
										<span className="photos_txt_item">사이즈</span>
									</span>
										</button>
									</li>
								</ul>
							</div>
							<div className="photos_menu_sub photos_menu_sub_effect">
								<strong className="photos_screen_out">효과 메뉴</strong>
								<ul className="photos_list_item photos_align_center photos_list_effect">
									<li>
										<button type="button" className="photos_btn_item photos_menu_btn_auto" data-click="effect:auto">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_auto"></span>
										<span className="photos_txt_item">자동조정</span>
									</span>
										</button>
									</li>
									<li>
										<button type="button" className="photos_btn_item photos_menu_btn_brightness" data-click="submenu:brightness">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_brightness"></span>
										<span className="photos_txt_item">밝기</span>
									</span>
										</button>
									</li>
									<li>
										<button type="button" className="photos_btn_item photos_menu_btn_contrast" data-click="submenu:contrast">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_contrast"></span>
										<span className="photos_txt_item">대비</span>
									</span>
										</button>
									</li>
									<li>
										<button type="button" className="photos_btn_item photos_menu_btn_saturation" data-click="submenu:saturation">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_saturation"></span>
										<span className="photos_txt_item">채도</span>
									</span>
										</button>
									</li>
									<li>
										<button type="button" className="photos_btn_item photos_menu_btn_warmth" data-click="submenu:warmth">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_warmth"></span>
										<span className="photos_txt_item">색온도</span>
									</span>
										</button>
									</li>
									<li>
										<button type="button" className="photos_btn_item photos_menu_btn_focus" data-click="submenu:focus">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_focus"></span>
										<span className="photos_txt_item">블러/포커스</span>
									</span>
										</button>
									</li>
									<li>
										<button type="button" className="photos_btn_item photos_menu_btn_vignette" data-click="submenu:vignette">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_vignette"></span>
										<span className="photos_txt_item">비네팅</span>
									</span>
										</button>
									</li>
								</ul>
							</div>
							<div className="photos_menu_sub photos_menu_sub_deco">
								<strong className="photos_screen_out">꾸미기 메뉴</strong>
								<ul className="photos_list_item photos_align_center photos_list_deco">
									<li>
										<button type="button" className="photos_btn_item photos_menu_btn_text" data-click="submenu:text">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_text"></span>
										<span className="photos_txt_item">텍스트</span>
									</span>
										</button>
									</li>
									<li>
										<button type="button" className="photos_btn_item photos_menu_btn_watermark" data-click="submenu:watermark">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_watermark"></span>
										<span className="photos_txt_item">워터마크</span>
									</span>
										</button>
									</li>
								</ul>
							</div>
						</div>
						<div className="photos_menu_main">
							<strong className="photos_screen_out">메인 메뉴</strong>
							<ul className="photos_list_main_menu photos_align_center">
								<li><button type="button" className="photos_ico_photos photos_btn_filter" data-click="mainmenu:filter" disabled>필터</button></li>
								<li><button type="button" className="photos_ico_photos photos_btn_crop" data-click="mainmenu:crop">편집</button></li>
								<li><button type="button" className="photos_ico_photos photos_btn_effect" data-click="mainmenu:effect">효과</button></li>
								<li><button type="button" className="photos_ico_photos photos_btn_effect_all" data-click="submenu:effectAll">효과</button></li>
								<li><button type="button" className="photos_ico_photos photos_btn_deco" data-click="mainmenu:deco">꾸미기</button></li>
								<li><button type="button" className="photos_ico_photos photos_btn_rotate_r" data-click="main:edit:rotate:right">회전</button></li>
								<li><button type="button" className="photos_ico_photos photos_btn_flip_h" data-click="main:edit:flip:horizontal">회전</button></li>
								<li><button onClick={() => {this.hide();}} type="button" className="photos_ico_photos photos_btn_crop" data-click="submenu:crop">편집</button></li>
								<li><button onClick={() => {this.hide();}} type="button" className="photos_ico_photos photos_btn_size" data-click="submenu:size">사이즈</button></li>
							</ul>

							<button type="button" className="photos_btn_quicklist photos_hide" data-click="menu:list">
								<span className="photos_bg_photos photos_num_list"></span>
							</button>
						</div>
						<div className="photos_menu_item">
							<div className="photos_sub_detail photos_sub_detail_filter">
								<strong className="photos_screen_out">필터</strong>
								<button type="button" className="photos_ico_photos photos_btn_origin" data-click="filter:OR00">ORIGIN</button>
							</div>
							<div className="photos_sub_detail photos_sub_detail_crop">
								<strong className="photos_screen_out">크롭/회전</strong>
								<div className="photos_detail_list">
									<em className="photos_screen_out">크롭 비율</em>
									<ul className="photos_list_info photos_list_crop photos_align_center">
									</ul>
								</div>
							</div>
							<div className="photos_sub_detail photos_sub_detail_size">
								<strong className="photos_screen_out">사이즈</strong>
								<div className="photos_detail_info">
									<div className="photos_info_btn photos_info_size">
										<div className="photos_bg_photos photos_size_input photos_size_width">
											<label htmlFor="width" className="photos_screen_out">넓이값 입력</label>
											<input type="text" id="width" className="photos_inp_photos" maxLength="4" />
										</div>
										<button type="button" className="photos_ico_photos photos_btn_lock" data-click="size:lock">비율 고정</button>
										<div className="photos_bg_photos photos_size_input photos_size_height">
											<label htmlFor="height" className="photos_screen_out">높이값 입력</label>
											<input type="text" id="height" className="photos_inp_photos" maxLength="4" />
										</div>
									</div>
								</div>
								<div className="photos_detail_list">
									<em className="photos_screen_out">리사이즈 목록</em>
									<ul className="photos_list_info photos_list_size photos_align_center" ></ul>
								</div>
							</div>
							<div className="photos_sub_detail photos_sub_detail_brightness">
								<strong className="photos_screen_out">밝기</strong>
								<div className="photos_effect_slider">
									<div className="photos_slider_bar photos_slider_brightness">
										<input className="pp_slider_input pp_hide" type="range" min="-150" max="150" step="1" start="0" />
									</div>
								</div>
							</div>
							<div className="photos_sub_detail photos_sub_detail_contrast">
								<strong className="photos_screen_out">대비</strong>
								<div className="photos_effect_slider">
									<div className="photos_slider_bar photos_slider_contrast">
										<input className="pp_slider_input pp_hide" type="range" min="-100" max="100" step="1" start="0" />
									</div>
								</div>
							</div>
							<div className="photos_sub_detail photos_sub_detail_saturation">
								<strong className="photos_screen_out">채도</strong>
								<div className="photos_effect_slider">
									<div className="photos_slider_bar photos_slider_saturation">
										<input className="pp_slider_input pp_hide" type="range" min="-100" max="100" step="1" start="0" />
									</div>
								</div>
							</div>
							<div className="photos_sub_detail photos_sub_detail_warmth">
								<strong className="photos_screen_out">색온도</strong>
								<div className="photos_effect_slider">
									<div className="photos_slider_bar photos_slider_warmth">
										<input className="pp_slider_input pp_hide" type="range" min="-100" max="100" step="1" start="0" />
									</div>
								</div>
							</div>
							<div className="photos_sub_detail photos_sub_detail_focus">
								<strong className="photos_screen_out">포커스</strong>
								<div className="photos_detail_info">
									<div className="photos_info_btn photos_info_focus">
										<button type="button" className="photos_ico_photos photos_btn_circle" data-click="focus:circle">원형</button>
										<button type="button" className="photos_ico_photos photos_btn_line" data-click="focus:linear">선형</button>
									</div>
								</div>
								<button type="button" className="photos_ico_photos photos_btn_origin" data-click="focus:original">ORIGIN</button>
							</div>
							<div className="photos_sub_detail photos_sub_detail_vignette">
								<strong className="photos_screen_out">비네팅</strong>
								<div className="photos_effect_slider">
									<div className="photos_slider_bar photos_slider_vignette">
										<input className="pp_slider_input pp_hide" type="range" min="-100" max="100" step="1" start="0" />
									</div>
								</div>
							</div>
							<div className="photos_sub_detail photos_sub_detail_effect_all">
								<strong className="photos_screen_out">효과</strong>
								<div className="photos_effect_slider_bg"></div>
								<div className="photos_effect_slider">
									<div className="photos_slider_bar photos_slider_brightness">
										<input className="pp_slider_input pp_hide" type="range" min="-150" max="150" step="15" start="0" mode="steps" />
									</div>
									<div className="photos_slider_bar photos_slider_contrast">
										<input className="pp_slider_input pp_hide" type="range" min="-100" max="100" step="10" start="0" mode="steps" />
									</div>
									<div className="photos_slider_bar photos_slider_saturation">
										<input className="pp_slider_input pp_hide" type="range" min="-100" max="100" step="10" start="0" mode="steps" />
									</div>
									<div className="photos_slider_bar photos_slider_warmth">
										<input className="pp_slider_input pp_hide" type="range" min="-100" max="100" step="10" start="0" mode="steps" />
									</div>
									<div className="photos_slider_bar photos_slider_focus">
										<input className="pp_slider_input pp_hide" type="range" min="-100" max="100" step="10" start="0" mode="steps" />
									</div>
								</div>
								<div className="photos_detail_list">
									<em className="photos_screen_out">효과 목록</em>
									<ul className="photos_list_info photos_list_effect_all photos_align_center">
										<li>
											<button type="button" className="photos_btn_info photos_menu_btn_brightness" data-click="effect:brightness">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_brightness"></span>
										<span className="photos_txt_item">밝기</span>
									</span>
											</button>
										</li>
										<li>
											<button type="button" className="photos_btn_info photos_menu_btn_contrast" data-click="effect:contrast">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_contrast"></span>
										<span className="photos_txt_item">대비</span>
									</span>
											</button>
										</li>
										<li>
											<button type="button" className="photos_btn_info photos_menu_btn_saturation" data-click="effect:saturation">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_saturation"></span>
										<span className="photos_txt_item">채도</span>
									</span>
											</button>
										</li>
										<li>
											<button type="button" className="photos_btn_info photos_menu_btn_warmth" data-click="effect:warmth">
									<span className="photos_inner_btn">
										<span className="photos_ico_photos photos_ico_warmth"></span>
										<span className="photos_txt_item">색온도</span>
									</span>
											</button>
										</li>
									</ul>
								</div>
							</div>
							<div className="photos_sub_detail photos_sub_detail_text">
								<strong className="photos_screen_out">텍스트</strong>
								<div className="photos_detail_info">
									<div className="photos_info_btn photos_info_text">
										<button type="button" className="photos_ico_photos photos_btn_add" data-click="text:add">텍스트 추가</button>
										<button type="button" className="photos_ico_photos photos_btn_text" data-click="text:color">텍스트 색상</button>
										<button type="button" className="photos_ico_photos photos_btn_bold" data-click="text:bold">텍스트 굵게</button>
									</div>
								</div>
								<button type="button" className="photos_ico_photos photos_btn_reset" data-click="text:reset">RESET</button>
							</div>
							<div className="photos_sub_detail photos_sub_detail_watermark">
								<strong className="photos_screen_out">워터마크</strong>
								<div className="photos_detail_info">
									<div className="photos_info_btn photos_info_watermark">
										<div className="photos_ico_photos photos_btn_add">
											<label htmlFor="addWatermark" className="photos_screen_out">사진올리기</label>
											<input className="photos_watermark_input photos_inp_file" id="addWatermark" type="file" accept="image/*" />
										</div>
										<button type="button" className="photos_btn_alpha photos_btn_disabled" data-click="watermark:alpha" disabled="disabled">
											<span className="photos_bg_photos"><span className="photos_screen_out">투명도</span>100<span className="photos_txt_percent">%</span></span>
										</button>
									</div>
								</div>
								<button type="button" className="photos_ico_photos photos_btn_reset" data-click="watermark:reset">RESET</button>
							</div>
							<button onClick={() => { this.show(); }} type="button" className="photos_btn_sub photos_btn_back" data-click="detailmenu:back"><span className="photos_ico_photos photos_ico_back">선택취소</span></button>
							<button onClick={() => { this.show(); }} type="button" className="photos_btn_sub photos_btn_ok" data-click="detailmenu:ok"><span className="photos_ico_photos photos_ico_ok">선택완료</span></button>
						</div>
					</div>
					<div className="photos_icon_animation photos_hide"></div>
				</div>

				<div className="photos_progressbar photos_hide"></div>
			</div>
		);
    }
}
